module.exports = __webpack_public_path__ + "img/upgrade_icon.284c2c50.svg";